import { FileTypeEnum } from "api/actor"
import { useCallback, useState } from "react"
import { downloadDocumentByStoredId } from "services/documentsAPI"
import { documentsAPI } from "services/swagger-api"

export const useFunnelDownload = () => {
  const [isDownloading, setIsDownloading] = useState<FileTypeEnum | null>(null)

  const onDownload = useCallback(async (productId: string, fileType: FileTypeEnum) => {
    setIsDownloading(fileType)
    try {
      const response = await documentsAPI.getSimulationDocumentsByProductId({ productId, fileType })
      if (response.storedFileId) {
        const res = await downloadDocumentByStoredId(response.storedFileId);
        const blob = new Blob([res], { type: `application/pdf` });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsDownloading(null)
    }
  }, [])
  return { 
  onDownload,
  isDownloading,
  setIsDownloading
  }
}
